<template>
  <div class="mt-2">
    <fcc-table
      striped
      hover
      responsive
      :items="allResponsaveis"
      :fields="fields"
      :optionsButton="options"
      :actions="actions"
      pagination
    />

    <fccModal
      idModal="modal-responsavel"
      :titleModal="titleModal"
      centered
      escondeFooter
      @close="limparForm"
    >
      <b-form @submit.prevent="salvar" autocomplete="off"
        ><div class="row mb-4">
          <div class="col">
            <fcc-select :options="equipes" v-model="form.equipe" required>Equipe</fcc-select>
          </div>
        </div>
        <div class="row mb-4">
          <div class="col">
            <fcc-select :options="solicitantes" v-model="form.responsavel" required
              >Responsável</fcc-select
            >
          </div>
        </div>

        <div class="row text-right">
          <div class="col"><fcc-button type="submit">Salvar</fcc-button></div>
        </div></b-form
      >
    </fccModal>
  </div>
</template>
<script>
import store from '@/store'
import { mapState } from 'vuex'
import axios from 'axios'

export default {
  data() {
    return {
      form: { equipe: null, responsavel: null },
      fields: [
        { key: 'idresponsavel', label: 'Id', sortable: true },
        { key: 'descricaoequipe', label: 'Equipe', sortable: true },
        { key: 'nomeresponsavel', label: 'Responsável', sortable: true },
        { key: 'actions', label: '', tdClass: 'no-print', thClass: 'no-print', active: true }
      ],
      actions: [
        {
          button: true,
          funcaoButton: 'deleteField',
          icon: 'trash',
          tooltip: 'Excluir',
          objpermCodigo: store.state.permissaoMenu.excluir
        }
      ],
      options: [
        {
          funcaoButton: 'adicionar',
          text: 'Adicionar',
          tooltip: 'Adicionar',
          icon: 'plus',
          objpermCodigo: store.state.permissaoMenu.adicionar
        }
      ]
    }
  },
  computed: {
    ...mapState('acompanhamentoDeProjetos', ['allResponsaveis', 'equipes', 'solicitantes']),
    titleModal() {
      return 'Adicionar Responsável'
    }
  },
  mounted() {
    this.atualizarItens()
  },
  methods: {
    limparForm() {
      this.form = { equipe: null, responsavel: null }
    },
    atualizarItens() {
      store
        .dispatch(
          'acompanhamentoDeProjetos/fetchAllResponsaveis',
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(() =>
          store.dispatch(
            'acompanhamentoDeProjetos/fetchSolicitantes',
            this.dadosLoginSession.fccTokenHeaders
          )
        )
        .then(() => this.$emit('carregado'))
        .catch(this.setErrorSystem)
    },
    adicionar() {
      this.$root.$emit('bv::show::modal', 'modal-responsavel')
    },
    salvar() {
      this.callConfirm('Deseja adicionar um responsável?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          this.responsavelAdicionar()
            .then(() => {
              this.carregaTexto()
              this.limparForm()
              this.atualizarItens()
              this.$root.$emit('bv::hide::modal', 'modal-responsavel')
              this.callToast(this.mensagensUpdate.adicionado)
            })
            .catch(this.setErrorSystem)
        }
      })
    },
    responsavelAdicionar() {
      const payload = {
        idResponsavel: 0,
        idEquipe: this.form.equipe.idequipe,
        cdResponsavel: this.form.responsavel?.usuariocomplemento?.usucompcdfuncionario,
        cdFuncionario: this.dadosUserSession.usuCdFuncionario
      }

      return axios.post(
        store.state.baseUrlGestaoProjetos + 'ProjetoResponsavel/Adicionar',
        payload,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    responsavelExcluir(idResponsavel) {
      return axios.delete(
        store.state.baseUrlGestaoProjetos + 'ProjetoResponsavel/Excluir/' + idResponsavel,
        this.dadosLoginSession.fccTokenHeaders
      )
    },
    deleteField(_, item) {
      this.callConfirm('Deseja excluir o responsável?', '').then((result) => {
        if (result.value) {
          this.carregaTexto(this.codeMensagem('C01'))
          this.responsavelExcluir(item.idresponsavel)
            .then(() => {
              this.carregaTexto()
              this.atualizarItens()
              this.callToast(this.mensagensUpdate.excluido, 'success')
            })
            .catch(this.setErrorSystem)
        }
      })
    }
  }
}
</script>